import React from "react";
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
    worlddata: any;
}

const WorldisyourCampus: React.FC<Props> = ({ worlddata }) => {
    return (
        <div id="World_yourCampus" className={styles.worldisyourCampus} style={{ backgroundColor: worlddata?.sectionBgColor || "#fff" }} >
            <Container>
                <Row>
                    <div className={styles.heading}>
                        <h2>{worlddata.sectionTitle}</h2>
                        <h3>{worlddata.sectionSubTitle}</h3>
                        <p>{worlddata.sectionDesc}</p>
                    </div>
                </Row>
                <div className={styles.clickTabsCountry}>
                    <Row>
                        {
                            worlddata?.studyCountries?.length > 0 &&
                            worlddata?.studyCountries?.map((studyCountrydata: any) => {
                                return (
                                    <Col lg={3} xl={3} md={4} sm={6} xs={6}>
                                        <div className={styles.countryFlag} >
                                            <div className={styles.countryBox}>
                                                <span className={styles.flag}>
                                                    <CustomImage src={studyCountrydata.imageUrl || "/images/artboard2.png"} width={60} height={32} alt={"flag.png"} />
                                                </span>
                                                <span className={styles.flagsapn}><p>{studyCountrydata.title}</p></span>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export default WorldisyourCampus;